(function ($) {
	$(document).ready(function () {
		$(document.body).on("click", ".searchDfToggler", function(e){
			e.preventDefault();
			$(".header__search--input").trigger('click');
		});

		$(".header__search--input").on("focusout", function () {
			const userInput = jQuery(this).val();
			jQuery(".dfd-searchbox-input").val(userInput);
		});
	});
})(jQuery);
